/* eslint-disable @typescript-eslint/no-empty-function */
import { useCallback, useEffect, useState } from 'react';
// eslint-disable-next-line import/no-duplicates
import { differenceInSeconds, format } from 'date-fns';
// eslint-disable-next-line import/no-duplicates
import ptBR from 'date-fns/locale/pt-BR';
import {
  Flex,
  Text,
  Box,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Heading,
  Badge,
  Tag,
  TagLabel,
} from '@chakra-ui/react';
// import { RiChatSmile3Line } from 'react-icons/ri';
import { Pagination } from '../../Pagination';
import { api } from '../../../../services/api';
import { useAuth } from '../../../../hooks/auth';

interface IPropsListAppointmens {
  vehicleSelected: string;
}

interface IAppointmentItem {
  id: string;
  conductor_id: string;
  vehicle_id: string;
  start_date: string;
  end_date: string;
  date: string;
  route: string;
  description: string;
  status: string;
  created_at: string;
  updated_at: string;
  conductor: {
    id: string;
    name: string;
    email: string;
  };
  vehicle: {
    name: string;
  };
}

interface Appointments {
  appointment: IAppointmentItem[];
  pagination: {
    page: number;
    take: number;
    total: number;
    totalPages: number;
  };
}

export function ListYouAppointments({
  vehicleSelected,
}: IPropsListAppointmens) {
  const { user } = useAuth();
  const [appointments, setListAppointments] = useState<Appointments>();
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [vehicleSelected]);

  useEffect(() => {
    const userId = user?.id;

    if (vehicleSelected === 'Nenhum veiculo selecionado' || !userId) {
      setListAppointments(undefined);
      return undefined;
    }

    let componentIsMounted = true;
    const registersPerPage = 6;

    api
      .get<Appointments>('/appointments/filter', {
        params: {
          vehicle_id: vehicleSelected,
          conductor_id: userId,
          // Compatibilidade com a API atual, que ainda não aplica
          // conductor_id: busca o veículo e confirma o usuário no cliente.
          take: 9999,
          page: 1,
        },
      })
      .then(response => {
        if (!componentIsMounted) return;

        const allAppointments = Array.isArray(response.data?.appointment)
          ? response.data.appointment
          : [];
        const userAppointments = allAppointments.filter(
          appointment =>
            appointment.conductor_id === userId &&
            appointment.vehicle_id === vehicleSelected,
        );
        const firstRegister = (page - 1) * registersPerPage;

        setListAppointments({
          appointment: userAppointments.slice(
            firstRegister,
            firstRegister + registersPerPage,
          ),
          pagination: {
            page,
            take: registersPerPage,
            total: userAppointments.length,
            totalPages: Math.ceil(userAppointments.length / registersPerPage),
          },
        });
      })
      .catch(() => {
        if (componentIsMounted) setListAppointments(undefined);
      });

    return () => {
      componentIsMounted = false;
    };
  }, [page, vehicleSelected, user?.id]);

  const handleVerifyDateIsNew = useCallback((date: string | number | Date) => {
    const difference = differenceInSeconds(new Date(), new Date(date));

    return difference >= 0 && difference <= 13800;
  }, []);

  const defineColorStatus = useCallback((status: string): string => {
    if (status === 'Pendente') {
      return 'yellow';
    }
    if (status === 'Recusado') {
      return 'red';
    }
    if (status === 'Aprovado') {
      return 'green';
    }
    return '';
  }, []);

  return (
    <Box
      overflow="auto"
      borderRadius={8}
      bg="gray.800"
      p={['4', '8']}
      // height="450"
    >
      <Flex justify="space-between" align="center">
        <Heading
          size="md"
          fontWeight="500"
          marginBottom="40px"
          textColor="blue.500"
        >
          Seus agendamentos
        </Heading>
      </Flex>

      <Table colorScheme="whiteAlpha">
        <Thead>
          <Tr>
            <Th>Usuários</Th>
            <Th>Data e hora de sai</Th>
            <Th>Data e hora de retorno</Th>
            <Th>Rota</Th>
            <Th>Descrição</Th>
            <Th>Status</Th>

            <Th width="8" />
          </Tr>
        </Thead>

        <Tbody>
          {appointments?.appointment.length === 0 && (
            <Tr>
              <Td colSpan={7} textAlign="center">
                Nenhum agendamento seu para este veículo.
              </Td>
            </Tr>
          )}
          {appointments?.appointment.map(appointmentitem => (
            <Tr key={appointmentitem.id}>
              <Td>
                <Box display="flex" alignItems="center" flexDirection="row">
                  {handleVerifyDateIsNew(appointmentitem.created_at) ? (
                    <Badge
                      position="absolute"
                      fontSize="x-small"
                      colorScheme="green"
                      ml="-10"
                    >
                      New
                    </Badge>
                  ) : (
                    ''
                  )}
                  <Box>
                    <Text fontWeight="bold">
                      {appointmentitem.conductor.name}{' '}
                    </Text>
                    <Text fontSize="sm" color="gray.300">
                      {appointmentitem.vehicle.name}
                    </Text>
                  </Box>
                </Box>
              </Td>

              <Td>
                {' '}
                {format(
                  new Date(appointmentitem.start_date),
                  'dd/MM/yyyy HH:mm:ss',
                  {
                    locale: ptBR,
                  },
                )}{' '}
              </Td>
              <Td>
                {' '}
                {format(
                  new Date(appointmentitem.end_date),
                  'dd/MM/yyyy HH:mm:ss',
                  {
                    locale: ptBR,
                  },
                )}{' '}
              </Td>
              <Td> {appointmentitem.route}</Td>
              <Td> {appointmentitem.description}</Td>
              <Td>
                <Tag
                  colorScheme={defineColorStatus(appointmentitem.status)}
                  borderRadius="full"
                >
                  <TagLabel>{appointmentitem.status}</TagLabel>
                </Tag>
              </Td>
              <Td>
                {/* <Popover>
                  <PopoverTrigger>
                    <Button as="a" size="sm" fontSize="sm" colorScheme="blue">
                      <Icon as={RiChatSmile3Line} fontSize="20" />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent bg="gray.700">
                    <PopoverArrow bg="gray.700" borderColor="gray.700" />
                    <PopoverCloseButton />
                    <PopoverHeader>Solicite um favor!</PopoverHeader>
                    <PopoverBody>
                      Caso queira pedir para que Bruno Luiz leve algo em algum
                      lugar que seja dentro da rota planejada, solicite por
                      aqui.
                    </PopoverBody>
                    <PopoverFooter d="flex" justifyContent="flex-end">
                      <ButtonGroup size="sm">
                        <Button colorScheme="blue">Verificar rota</Button>
                      </ButtonGroup>
                    </PopoverFooter>
                  </PopoverContent>
                </Popover> */}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      {!!appointments?.pagination.total && (
        <Pagination
          totalCountOfRegisters={appointments.pagination.total}
          currentPage={page}
          onPageChange={setPage}
          registersPerPage={appointments.pagination.take}
        />
      )}
    </Box>
  );
}
